//路由菜单有关语言包
export default {
  工作台: '工作台',
  线索: '线索',
  销售线索: '销售线索',
  销售线索详情: '销售线索详情',
  线索池: '线索池',
  客户: '客户',
  客户管理: '客户管理',
  客户详情: '客户详情',
  客户公海: '客户公海',
  商机: '商机',
  商机管理: '商机管理',
  商机详情: '商机详情',
  报价单: '报价单',
  报价单管理: '报价单管理',
  报价单详情: '报价单详情',
  报价单更新: '报价单更新',
  销售合同: '销售合同',
  销售合同管理: '销售合同管理',
  销售合同详情: '销售合同详情',
  更新销售合同: '更新销售合同',
  产品: '产品',
  产品管理: '产品管理',
  产品管理详情: '产品管理详情',
  工作日程: '工作日程',
  日历看板: '日历看板',
  日程列表: '日程列表',
  通话列表: '通话列表',
  数据分析: '数据分析',
  线索分析: '线索分析',
  客户画像: '客户画像',
  成员榜单: '成员榜单',
  // ---------- setting--------------
  设置中心: '设置中心',
  组织权限: '组织权限',
  组织用户: '组织用户',
  已离职用户: '已离职用户',
  角色权限: '角色权限',
  对象管理: '对象管理',
  系统对象: '系统对象',
  对象详情: '对象详情',
  外部对象: '外部对象',
  审批模板: '审批模板',
  映射规则: '映射规则',
  对象下字段: '对象下字段',
  全局字段: '全局字段',
  线索池管理: '线索池管理',
  规则管理: '规则管理',
  对象映射规则: '对象映射规则',
  对象映射规则设置: '对象映射规则设置',
  对象映射规则详情: '对象映射规则详情',
  接口映射规则: '接口映射规则',
  接口映射规则设置: '接口映射规则设置',
  添加接口映射规则: '添加接口映射规则',
  编辑接口映射规则: '编辑接口映射规则',
  业务插件管理: '业务插件管理',
  火山外呼人员管理: '火山外呼人员管理',
  火山外呼池管理: '火山外呼池管理',
  外呼号码管理: '外呼号码管理',
  流程管理: '流程管理',
  阶段流程设置: '阶段流程设置',
  商机阶段详情: '商机阶段详情',
  火山语音费用: '火山语音费用',
  费用概览: '费用概览',
  账单明细: '账单明细',
  e签宝电子签章: 'e签宝电子签章',
  自动化流程: '自动化流程',
  自动化管理: '自动化管理',
  返回首页: '返回首页'
};
